import React from 'react';

const ErrorIcon = ({ className }) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<path
			className={className}
			d="M21.0999 11.9999C21.0999 14.4134 20.1412 16.728 18.4346 18.4346C16.728 20.1412 14.4134 21.0999 11.9999 21.0999C9.58643 21.0999 7.27181 20.1412 5.56523 18.4346C3.85865 16.728 2.8999 14.4134 2.8999 11.9999C2.8999 9.58643 3.85865 7.27181 5.56523 5.56523C7.27181 3.85865 9.58643 2.8999 11.9999 2.8999C14.4134 2.8999 16.728 3.85865 18.4346 5.56523C20.1412 7.27181 21.0999 9.58643 21.0999 11.9999ZM13.202 18.002C13.5208 17.6832 13.6999 17.2508 13.6999 16.7999C13.6999 16.349 13.5208 15.9166 13.202 15.5978C12.8832 15.279 12.4508 15.0999 11.9999 15.0999C11.549 15.0999 11.1166 15.279 10.7978 15.5978C10.479 15.9166 10.2999 16.349 10.2999 16.7999C10.2999 17.2508 10.479 17.6832 10.7978 18.002C11.1166 18.3208 11.549 18.4999 11.9999 18.4999C12.4508 18.4999 12.8832 18.3208 13.202 18.002ZM11.9999 5.4999C11.549 5.4999 11.1166 5.67901 10.7978 5.99782C10.479 6.31663 10.2999 6.74903 10.2999 7.1999V11.9999C10.2999 12.4508 10.479 12.8832 10.7978 13.202C11.1166 13.5208 11.549 13.6999 11.9999 13.6999C12.4508 13.6999 12.8832 13.5208 13.202 13.202C13.5208 12.8832 13.6999 12.4508 13.6999 11.9999V7.1999C13.6999 6.74903 13.5208 6.31663 13.202 5.99782C12.8832 5.67901 12.4508 5.4999 11.9999 5.4999Z"
			fill="#E02424"
			stroke="#E02424"
		/>
	</svg>
);

export default ErrorIcon;
